// extracted by mini-css-extract-plugin
var _1 = "OslNA";
var _2 = "GiPIG";
export { _1 as "dir-column", _2 as "dir-row" }
